import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-hr-solution',
  templateUrl: './hr-solution.component.html',
  styleUrls: ['./hr-solution.component.scss']
})
export class HrSolutionComponent implements OnInit {

  constructor(private meta: Meta) { 
    this.meta.removeTag('name=keywords');
    this.meta.removeTag('name=description');
    this.meta.addTags([ 
      { name: 'description', content: 'Explore our comprehensive HR Management solutions at OSIT. We specialize in providing tailored HR software and services to streamline your human resource processes in Riyadh, Saudi Arabia. Discover how our HR solutions can enhance your workforce management and HR efficiency.' }, 
      { name: 'keywords', content: 'osit,it,saudi it,software development,website development' } 
  ]);
  }

  ngOnInit() {
  }

}
